export const parseLabels = (labels: any): string[] => {
    if (!labels) return []

    if (Array.isArray(labels)) {
        return labels.filter(Boolean)
    }

    if (typeof labels === 'string') {
        try {
            const parsed = JSON.parse(labels)
            if (Array.isArray(parsed)) {
                return parsed.filter(Boolean)
            }
        } catch {
            // If not valid JSON, treat as comma-separated string
            return labels
                .split(',')
                .map((s: string) => s.trim())
                .filter(Boolean)
        }
    }

    return []
}

export const getImagePreviewUrl = (image: File | string | null): string | null => {
    if (!image) return null

    if (image instanceof File) {
        return URL.createObjectURL(image)
    }

    if (typeof image === 'string' && image.trim()) {
        return image
    }

    return null
}

export const normalizeLabel = (label: string) => {
    const cleaned = label.trim()
    if (!cleaned) return ''

    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase()
}

export const createPreview = (watchedItem: any, setImageDataUrls: any, field: any) => {
    const previewUrl = getImagePreviewUrl(watchedItem)
    setImageDataUrls((prev) => ({ ...prev, [field]: previewUrl }))
    return () => {
        if (previewUrl && watchedItem instanceof File) {
            URL.revokeObjectURL(previewUrl)
        }
    }
}